import { QueryClientProvider } from '@tanstack/react-query';
import { JSX, PropsWithChildren } from 'react';
import { AppQueryClient } from '../../config/AppQueryClient.config';
import { BusinessContextModel } from '../../model/BusinessContext.model';
import {
  AppQueryClientBusinessContextSwitcher,
} from '../AppQueryClientBusinessContextSwitcher/AppQueryClientBusinessContextSwitcher';

type Props = {
  businessContext: BusinessContextModel | null;
} & PropsWithChildren;

export const AppQueryClientProvider = ({ children, businessContext }: Props): JSX.Element => {
  return <QueryClientProvider client={AppQueryClient}>
    <AppQueryClientBusinessContextSwitcher businessContext={businessContext} />
    {children}
  </QueryClientProvider>;
};

